import React from "react";
import { Box, Typography, Link, Container, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from "react-i18next";
import { SITE_NAME } from "../../utils/constants";



const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="footer"
      sx={{
        textAlign: "center",
        py: 8,
        backgroundColor: "transparent",
        color: theme.palette.text.primary
      }}
    >
      <Typography variant="body2" sx={{ mb: 1, color: theme.palette.text.secondary }}>
        &copy; {new Date().getFullYear()} {t('common.footerCopyright', { siteName: SITE_NAME })}{' '}
        <Link
          href="https://x.com/JC__cooks"
          sx={{
            color: theme.palette.primary.main,
            textDecoration: 'none',
            '&:hover': {
              color: theme.palette.primary.dark,
              textDecoration: 'underline'
            }
          }}
        >
          JC is fast
        </Link>
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: theme.palette.text.secondary }}>
        {t('common.footerRightsReserved')}
      </Typography>
      <Stack direction="row" spacing={2} justifyContent={"center"} sx={{
        textAlign: isXs ? 'center' : 'right',
      }}>
        <Link
          href="https://x.com/FlokiTools"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
          sx={{ textDecoration: 'none' }}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
          >
            X (formerly Twitter)
          </Typography>
        </Link>
        <Link
          href="https://discord.gg/jUKB4kH3"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Discord"
          sx={{ textDecoration: 'none' }}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': {
                color: theme.palette.secondary.main,
              },
            }}
          >
            Discord
          </Typography>
        </Link>
      </Stack>
    </Box>
  );
};

export default Footer;